import React from "react";

const Slogan = ({ title }) => {
    return (
        <div className="contact-slogan border-t border-dark-border py-2">
               <div className="text-primary md:text-lg text-sm italic">
                {title}
            </div>
        </div>
    )
};

export default Slogan;
